export const EcomWrapperEventTypeEnumsObj = {
    WRONG_ECOM_SDK_ENUM_VALUE: "WRONG_ECOM_SDK_ENUM_VALUE",
    START_PAYMENT_CALL_FAIL_SDK_NOT_LOADED: "START_PAYMENT_CALL_FAIL_SDK_NOT_LOADED",
};
